export const SET_USER = 'SET_USER';
export const USER_IS_LOADING = 'USER_IS_LOADING';
export const USER_STATUS = 'USER_STATUS';
export const FETCH_USER = 'FETCH_USER';
export const ARTICLE = 'ARTICLE';
export const ARTICLE_STATUS = 'ARTICLE_STATUS';

/* Export each action file below */
export * from './Authentication/actions';
export * from './Article/actions';